import React, { Component } from 'react';
import { connect } from 'react-redux';
import onClickOutside from 'react-onclickoutside';
import { selectedAllEmployeesAllPages } from 'src/reducers/settings/coordinations';

import styles from './SelectEmployeeMenu.scss';

const SelectEmployeeMenu = onClickOutside(
  class extends Component {
    handleClickOutside = () => {
      this.props.hide();
    };

    render() {
      const { dispatch } = this.props;

      return (
        <div className={styles.baloonWrap}>
          <div className={styles.baloon}>
            <ul className={styles.links}>
              <li>
                <a
                  onClick={() => {
                    dispatch(selectedAllEmployeesAllPages(true));
                  }}
                  role="presentation"
                >
                  全ページの従業員を選択
                </a>
              </li>
              <li>
                <a
                  onClick={() => {
                    dispatch(selectedAllEmployeesAllPages(false));
                  }}
                  role="presentation"
                >
                  全ページの従業員を解除
                </a>
              </li>
            </ul>
          </div>
        </div>
      );
    }
  }
);

export default connect()(SelectEmployeeMenu);
